<template>
  <div class="order-now">
    <RestaurantModal
      :restaurantDetails="restaurantToShow"
      v-if="showMenu"
      @close-restaurant-modal="triggerRestaurantMenu"
    />
    <div class="card-view-wrap">
      <div class="container">
        <h3>Order Now!</h3>
        <div class="cards" id="infinite-list">
          <CardView
            @show-restaurant="triggerRestaurantMenu"
            v-for="(restaurant, index) in restaurantsData"
            :key="index"
            :restaurant="restaurant"
          />
        </div>
        <div class="load-more-button">
          <button
            v-show="!loadRestaurants"
            class="button-2"
            @click.prevent="getNextRestaurants"
          >
            {{ this.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardView from "../components/CardView";
import RestaurantModal from "../components/RestaurantModal";
//import firebase from "firebase/app";
import db from "../firebase/firebaseInit";
import "mosha-vue-toastify/dist/style.css";

export default {
  name: "OrderNowInfiniteScroll",
  components: {
    CardView,
    RestaurantModal,
  },
  data() {
    return {
      restaurantsData: [],
      showMenu: false,
      restaurantToShow: null,
      lastRestaurantRetrieved: null,
      loadRestaurants: true,
      buttonText: "Load More",
      startDisplay: false,
      //orderNowContainer: null,
    };
  },
  /*
  created() {
    // ONLY USE WINDOW IN VUE FOR EVENTlistener, SO FAR THATS WHAT IS WORKING :(, DEBUGGIN..

    //window.addEventListener("DOMContentLoaded", this.getNextRestaurants);
    //this.orderNowContainer = document.querySelector(".order-now");
    this.getNextRestaurants();
    //window.addEventListener("scroll", this.handleScrollLoading);
  },
  */
  mounted() {
    // Detect when scrolled to bottom.
    const listElm = document.querySelector("#infinite-list");

    const scrollHandle = () => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.getNextRestaurants();
      }
    };
    listElm.addEventListener("scroll", scrollHandle);

    // Initially load some items.
    this.getNextRestaurants();
  },
  methods: {
    /**
     * Infinite Scroll Trials :(
     */
    /*
    handleScrollLoading() {
      let triggerHeight = window.scrollTop + window.offsetHeight;
      if (triggerHeight >= window.scrollHeight) {
        this.getNextRestaurants();
      }
    },
    */
    async getNextRestaurants() {
      if (this.loadRestaurants) {
        const ref = db
          .collection("restaurants")
          .orderBy("name")
          .startAfter(this.lastRestaurantRetrieved || 0)
          .limit(8);

        const data = await ref.get();

        data.docs.forEach((doc) => {
          const restaurantData = doc.data();

          const restaurant = {
            //ID not working
            //id: restaurantData.uid,
            name: restaurantData.name,
            photo: restaurantData.photo,
            location: restaurantData.location,
          };

          this.restaurantsData.push(restaurant);
          /*
          this.restaurantsData.filter((res) =>
            res.name != restaurant.name ? restaurant : null
          );
          console.log(restaurant.name);
          */
          /*
        // Doesnt seem to be working in Vue , to see if loaded all data.
        //FIXED, DOESNT WORK INSIDE
        if (data.empty) {
          console.log("Done");
        }
        */
        });
        this.lastRestaurantRetrieved = data.docs[data.docs.length - 1];
        //console.log("restaurant : ", this.lastRestaurantRetrieved);
        this.startDisplay = true;

        if (data.empty) {
          //console.log("Done");
          this.loadRestaurants = false;
          this.buttonText =
            "You Have Reached the End of the List! But Don't Worry, More Restaurants Would Soon Come to the Rescue!";
          // Dont know why not removing ahhh
          //window.removeEventListener("click", this.getNextRestaurants);
        }
      }
    },
    /*
    async getNRestaurants() {
      const dataBase = db.collection("restaurants");
      const data = await dataBase.get();
      data.docs.forEach((doc) => {
        const restaurant = {
          name: doc.data().name,
          photo: doc.data().photo,
          location: doc.data().location,
        };
        this.restaurantsData.push(restaurant);
      });
    },
    */
    triggerRestaurantMenu(res) {
      this.restaurantToShow = res;
      this.showMenu = !this.showMenu;
    },
  },
};
</script>

<style lang="scss" scoped>
.cards {
  overflow: auto;
  height: 100vh;
  width: 100%;
  //height: 100%;
  //border: 2px solid #dce4ec;
  border-radius: 8px;
  //margin: 30px;
}

.load-more-button {
  .button-1 {
    margin: 0 auto;
    margin-top: 30px;
    display: block;
    cursor: pointer;
  }

  .button-2 {
    margin: 0 auto;
    margin-top: 30px;
    display: block;
    width: 100%;
    background-color: #000;
    border: none;
    font-weight: 500;
    //transition: 0.3s;

    @media (max-width: 900px) {
      height: 100px;
    }
  }
}

.order-now {
  p {
    margin-top: 20px;
    text-align: center;
    font-size: 40px;
  }
}

.card-view-wrap {
  h3 {
    font-weight: 300;
    font-size: 28px;
    margin-bottom: 32px;
  }
}
</style>
